export default {
  "ERRORS:NOT_FOUND:TITLE-TEXT": "पेज नहीं मिला."
};